import {
  ADAPTER,
  CONTRACT_TYPE,
  contract_type_names,
  EXPIRY_METHOD,
  expiry_method_names,
  SIZING_METHOD,
  sizing_method_names,
  STATUS,
  STRIKE_METHOD,
  strike_method_names,
} from '@voladeum/client';
import { Strategy } from 'client/voladeum/strategies/types';

import { EMPTY_ARRAY } from '../../constants';

export const strategy_default: Strategy = {
  strategy_id: 0,
  strategy_name: '',
  pair_id: 0,
  pair_name: '',
  user_id: 0,
  user_name: '',
  adapter_id: ADAPTER.KRAKEN,
  adapter_name: '',
  base_currency_id: 0,
  base_currency_name: '',
  quote_currency_id: 0,
  quote_currency_name: '',
  sizing_method_id: SIZING_METHOD.RISK,
  sizing_method_name: sizing_method_names[SIZING_METHOD.RISK],
  max_position_pct: 0.02,
  max_position_pct_formatted: '2%',
  max_daily_loss_pct: 0.05,
  max_daily_loss_pct_formatted: '5%',
  max_drawdown_pct: 0.2,
  max_drawdown_pct_formatted: '20%',
  slippage_tolerance_pct: 0.005,
  slippage_tolerance_pct_formatted: '0.5%',
  backtest_lookback_days: 30,
  backtest_lookback_days_formatted: '30',
  activation_threshold: 1,
  activation_threshold_formatted: '1',
  stop_loss_offset_pct: 0.02,
  stop_loss_offset_pct_formatted: '2%',
  take_profit_offset_pct: 0.05,
  take_profit_offset_pct_formatted: '5%',
  take_profit_trail_pct: 0.01,
  take_profit_trail_pct_formatted: '1%',
  contract_type_id: CONTRACT_TYPE.OPTION,
  contract_type_name: contract_type_names[CONTRACT_TYPE.OPTION],
  strike_method_id: STRIKE_METHOD.NEAREST_ATM,
  strike_method_name: strike_method_names[STRIKE_METHOD.NEAREST_ATM],
  strike_value: null,
  strike_value_formatted: '',
  expiry_method_id: EXPIRY_METHOD.DAYS_AHEAD,
  expiry_method_name: expiry_method_names[EXPIRY_METHOD.DAYS_AHEAD],
  expiry_value: 7,
  expiry_value_formatted: '7',
  since_milliseconds: 0,
  since_utc: '',
  since_utc_formatted: '',
  to_milliseconds: 0,
  to_utc: '',
  to_utc_formatted: '',
  status_id: STATUS.ACTIVE,
  status_name: '',
  triggers: EMPTY_ARRAY,
  indicators: EMPTY_ARRAY,
  created_date: new Date(),
  update_date: new Date(),
  uuid: '',
};
